module.exports = __webpack_public_path__ + "static/media/reservations.820b6055.svg";